import { Component, Input, OnInit, ChangeDetectorRef } from '@angular/core';
import { NzDrawerRef, NzDrawerService } from 'ng-zorro-antd/drawer';
import { Observable, finalize } from 'rxjs';
import { IGetTwitterPostsData } from '../../Models/ITwitterPost';
import { TwitterService } from '../../Services/twitter.service';
import {faExternalLink} from '@fortawesome/free-solid-svg-icons';
import { TwitterCommentDto, ITwitterComment } from '../../Models/ITwitterComment';
import { HelperFunctions } from '../../../../helpers/HelperFunctions';

@Component({
  selector: 'app-twitter-comments',
  templateUrl: './twitter-comments.component.html',
  styleUrl: './twitter-comments.component.scss'
})
export class TwitterCommentsComponent implements OnInit {
  @Input() postId?: string;
  comments: Array<ITwitterComment> = [];
  isLoading = false;

  isLoadingComments = false;
  commentCount: number = 0;
  errorComments: string = ''

  error: string = '';

  constructor(
    private twitterService: TwitterService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    if (this.postId) {
      this.loadPostComments();
    } else {
      this.error = 'No post ID provided';
    }
  }

  
  loadPostComments(): void {
    this.isLoadingComments = true;
    this.errorComments = '';
    
    this.twitterService.getPostComments(this.postId as string)
      .pipe(
        finalize(() => {
          this.isLoadingComments = false;
          this.cdr.detectChanges(); // Force change detection
        })
      )
      .subscribe({
        next: (response) => {
          if (response) {
            this.comments = Array.isArray(response) ? response : [response];
            this.commentCount = this.comments.length;
          } else {
            this.errorComments = 'No comments found or invalid response format';
            console.warn('No comments data in response:', response);
          }
        },
        error: (error) => {
          this.errorComments = 'Failed to load comments. Please try again.';
          console.error('Error loading comments:', error);
        }
      });
  }

  formatDatetime(time: string): string {
    return HelperFunctions.formatDatetime(time);
  }

 
 getInitials(fullName: string): string {
   return HelperFunctions.getInitials(fullName);
 }
  
}
